import {
  ApiError,
  KeyDate,
  OverviewReport,
  QuickSightDashboard,
  RemovedUserReport,
  ReportingPeriod,
} from '@core/models';

export interface State {
  closeSubmissionPeriodError: ApiError;
  closeSubmissionPeriodLoading: boolean;
  createKeyDateError: ApiError;
  createKeyDateLoading: boolean;
  createReportingPeriodError: ApiError;
  createReportingPeriodLoading: boolean;
  dashboards: QuickSightDashboard[];
  dashboardsError: ApiError;
  dashboardsLoading: boolean;
  deleteKeyDateError: ApiError;
  deleteKeyDateLoading: boolean;
  deleteReportingPeriodError: ApiError;
  deleteReportingPeriodLoading: boolean;
  forceGrantSubmissionError: ApiError;
  forceGrantSubmissionLoading: boolean;
  generateDashboardDataError: ApiError;
  generateDashboardDataLoading: boolean;
  keyDates: KeyDate[];
  keyDatesError: ApiError;
  keyDatesLoading: boolean;
  overviewReport: OverviewReport[];
  overviewReportError: ApiError;
  overviewReportLoading: boolean;
  removedUserReport: RemovedUserReport[];
  removedUserReportError: ApiError;
  removedUserReportLoading: boolean;
  reportingPeriods: ReportingPeriod[];
  reportingPeriodsError: ApiError;
  reportingPeriodsLoading: boolean;
  updateDashboardError: ApiError;
  updateDashboardLoading: boolean;
  updateKeyDateError: ApiError;
  updateKeyDateLoading: boolean;
  updateReportingPeriodError: ApiError;
  updateReportingPeriodLoading: boolean;
}

export const initialState: State = {
  closeSubmissionPeriodError: null,
  closeSubmissionPeriodLoading: false,
  createKeyDateError: null,
  createKeyDateLoading: false,
  createReportingPeriodError: null,
  createReportingPeriodLoading: false,
  dashboards: [],
  dashboardsError: null,
  dashboardsLoading: false,
  deleteKeyDateError: null,
  deleteKeyDateLoading: false,
  deleteReportingPeriodError: null,
  deleteReportingPeriodLoading: false,
  forceGrantSubmissionError: null,
  forceGrantSubmissionLoading: false,
  generateDashboardDataError: null,
  generateDashboardDataLoading: false,
  keyDates: [],
  keyDatesError: null,
  keyDatesLoading: false,
  overviewReport: [],
  overviewReportError: null,
  overviewReportLoading: false,
  removedUserReport: [],
  removedUserReportError: null,
  removedUserReportLoading: false,
  reportingPeriods: [],
  reportingPeriodsError: null,
  reportingPeriodsLoading: false,
  updateDashboardError: null,
  updateDashboardLoading: false,
  updateKeyDateError: null,
  updateKeyDateLoading: false,
  updateReportingPeriodError: null,
  updateReportingPeriodLoading: false,
};
